import React from 'react';

import { BaseBox } from '../BaseBox';
import { VStackProps } from './interface';

export const VStack = (props: VStackProps) => {
  return <BaseBox {...props} display="flex" flexDirection="column" />;
};
